<div class="column pr-0 pl-0 pb-0">
    <div [formGroup]="selectChoiceForm" class="box" [style]="styleOutterDiv">
        <div class="columns is-aligned-center">
            <div class="column">
                @if (cmsData$ | async; as cmsData) {
                    @if (cmsData.title) {
                        <div>
                            <span
                                class="icon-and-text {{
                                    isMobile && 'is-stacked'
                                }} has-text-weight-semibold icon-and-text {{ cmsData.textColor }} is-fullwidth"
                            >
                                <div
                                    class="columns is-aligned-center is-mobile is-vertical-mobile"
                                    [ngStyle]="{ color: isFaiPureFiber ? 'white' : 'unset' }"
                                >
                                    @if (cmsData.icon) {
                                        <div class="column is-narrow is-paddingless">
                                            <span class="icon is-marginless {{ isMobile ? 'is-huge' : 'is-large' }}">
                                                <i [class]="cmsData.icon" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    } @else if (cmsData.titleLogo || isCompatiblePromoFoyer) {
                                        <div class="column is-narrow">
                                            <div class="logo-container" [ngClass]="isFaiPureFiber ? 'is-bigger' : ''">
                                                <img
                                                    [src]="
                                                        'https://www.bouyguestelecom.fr/static/wbm/media/banners/' +
                                                            cmsData.titleLogo +
                                                            '.webp' || 'assets/checkout/big.svg'
                                                    "
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    }
                                    <div class="column has-text-centered-mobile">
                                        @if (cmsData.sticker) {
                                            <div class="sticker mb-1 is-hidden-touch">
                                                {{ cmsData.sticker }}
                                            </div>
                                        }
                                        @if (cmsData.stickerMobile) {
                                            <div class="sticker mb-1 is-hidden-desktop">
                                                {{ cmsData.stickerMobile }}
                                            </div>
                                        }
                                        <div
                                            class="title is-level-5 is-marginless"
                                            [ngStyle]="{ color: isFaiPureFiber ? 'white' : 'unset' }"
                                            [ngClass]="{
                                                'is-hidden-touch': cmsData.titleMobile,
                                            }"
                                            [innerHTML]="cmsData.title"
                                        ></div>
                                        @if (cmsData.titleMobile) {
                                            <div
                                                class="title is-hidden-desktop is-level-5 is-marginless"
                                                [ngStyle]="{ color: isFaiPureFiber ? 'white' : 'unset' }"
                                                [innerHTML]="cmsData.titleMobile"
                                            ></div>
                                        }
                                        @if (cmsData.subtitle) {
                                            <span
                                                class="text is-level-1 has-text-weight-normal is-marginless is-block"
                                                [innerHTML]="cmsData.subtitle"
                                            ></span>
                                        }
                                        @if (cmsData.mentions) {
                                            <div class="mt-1">
                                                <span
                                                    class="text is-level-2 has-text-weight-normal is-marginless"
                                                    [innerHTML]="cmsData.mentions"
                                                ></span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </span>
                        </div>
                    } @else {
                        <checkout-default-bloc [suggestedProductLabel]="suggestedProductLabel" [isMobile]="isMobile" />
                    }
                } @else {
                    <checkout-default-bloc [suggestedProductLabel]="suggestedProductLabel" [isMobile]="isMobile" />
                }
            </div>
            <div class="column is-narrow">
                <div class="radios is-flex-nowrap is-horizontal-mobile">
                    <div class="radio-tile is-horizontal is-narrow-desktop is-marginless">
                        <input
                            checkoutCy="offer_control_choice_yes"
                            [value]="true"
                            formControlName="choiceControl"
                            id="offer_control_choice_yes"
                            name="choiceControl"
                            type="radio"
                            [attr.disabled]="
                                (selectChoiceForm.get('choiceControl').value !== true && !!waitForCartModifications) ||
                                null
                            "
                        />
                        <label for="offer_control_choice_yes" class="radio-label">
                            <span><span class="radio-title">Oui</span></span>
                        </label>
                    </div>
                    <div class="radio-tile is-horizontal is-narrow-desktop is-marginless">
                        <input
                            checkoutCy="offer_control_choice_no"
                            [value]="false"
                            formControlName="choiceControl"
                            id="offer_control_choice_no"
                            name="choiceControl"
                            type="radio"
                            [attr.disabled]="
                                (selectChoiceForm.get('choiceControl').value !== false && !!waitForCartModifications) ||
                                null
                            "
                        />
                        <label for="offer_control_choice_no" class="radio-label">
                            <span><span class="radio-title">Non</span></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-content select="[includedContent]"></ng-content>
</div>
